import * as React from "react";
import { memo } from "react";

const SvgWhiteboard = (props) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 22 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M21.94 4.177a.38.38 0 0 0-.253-.253h-.042c-.042 0-.042 0-.085-.042L11.94.632A.952.952 0 0 0 11.055 0a.932.932 0 0 0-.886.59L.464 3.883c-.042 0-.042 0-.084.042H.338a.38.38 0 0 0-.254.253.61.61 0 0 0-.084.295v13.924c0 .337.253.59.59.59h20.802c.337 0 .59-.253.59-.59V4.472c.043-.126 0-.21-.042-.295ZM11.054 1.941a.96.96 0 0 0 .802-.422l7.004 2.363H3.122l7.088-2.405c.17.253.464.464.844.464Zm4.6 16.117v-.801h3.248v.801h-3.249Zm-.844-1.645v1.645H.928V4.768h20.168v13.29h-1.35v-1.645H14.81ZM11.054.717c.127 0 .254.127.254.253a.272.272 0 0 1-.254.254.272.272 0 0 1-.253-.254c0-.126.085-.253.253-.253Z"
      fill="#000"
    />
    <path
      d="M4.768 17.13h-2.7c-.253 0-.422.17-.422.422 0 .253.169.422.422.422h2.7c.253 0 .422-.169.422-.422a.423.423 0 0 0-.422-.422ZM8.776 17.13h-2.7c-.253 0-.422.17-.422.422 0 .253.169.422.422.422h2.7c.253 0 .422-.169.422-.422s-.169-.422-.422-.422ZM12.785 17.13h-2.7c-.254 0-.423.17-.423.422 0 .253.17.422.422.422h2.7c.254 0 .422-.169.422-.422a.423.423 0 0 0-.421-.422Z"
      fill="#000"
    />
  </svg>
);

const Memo = memo(SvgWhiteboard);
export default Memo;
